/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import Typography from '@digital-hig/typography';
import DOMPurify from 'isomorphic-dompurify';
import {
  Box, CardMedia, CardActions, CardContent,
} from '@mui/material';
import Link from '@mui/material/Link';
import MuiTypography from '@mui/material/Typography';
import { CardDivider } from '@digital-hig/card';
import Skeleton from '@mui/material/Skeleton';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CardRootElement } from './style';

const CardDetails = ({
  headline, displayName, logo, handleViewMore, type, localImg, eyebrow, view, outsideClass,
  dataWatVal, dataWatLoc, cardDescClass, link, isTitleTranslate,
}) => {
  const [imgLoading, setImgLoading] = useState(true);
  const { t } = useTranslation();

  const viewClick = (e) => {
    e.preventDefault();
    handleViewMore();
  };

  return (
    <CardRootElement className="card-action">
      {(type !== 'contentOnly' && logo) && (
        <Box className={`${'default-card-image'} ${localImg ? 'features-default-card-image' : ''} ${outsideClass || ''}`}>
          <CardMedia
            alt={displayName}
            component="img"
            height="205"
            image={logo}
            onLoad={() => setImgLoading(false)}
            data-testid="card-media"
          />
          {imgLoading && <Skeleton className="shimmer-card" variant="rectangular" width="100%" height="100%" />}
        </Box>
      )}
      <CardContent>
        {eyebrow && (
          <Typography
            className="eyebrow-title"
            color="ink-on-background"
            sx={{
              mb: 3,
            }}
            variant="eyebrow"
          >
            {t(eyebrow)}
          </Typography>
        )}
        <Typography
          sx={{
            mb: 3,
          }}
          variant="headline-small"
          className="card-heading"
        >
          {isTitleTranslate ? t(displayName) : displayName}
        </Typography>
        <MuiTypography
          className={`card-desc ${cardDescClass}`}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t(headline)) }}
        />
      </CardContent>
      {view && <CardDivider />}
      {view && link && (
        <CardActions
          sx={{
            mt: 6,
          }}
        >
          <Link className="view-button" data-wat-val={dataWatVal} data-wat-loc={dataWatLoc} href={link} onClick={viewClick}>
            <svg className="default" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="utility/cta-arrow-right"><path id="stroke" d="M12.0604 8L16.0555 12M16.0555 12L12.0604 16M16.0555 12H7M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></g></svg></svg>
            <svg className="hover" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75ZM12.5911 7.47C12.2984 7.17692 11.8235 7.17663 11.5304 7.46934C11.2373 7.76206 11.237 8.23693 11.5298 8.53L14.2464 11.25H7C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75H14.2464L11.5298 15.47C11.237 15.7631 11.2373 16.2379 11.5304 16.5307C11.8235 16.8234 12.2984 16.8231 12.5911 16.53L16.5861 12.53C16.8786 12.2372 16.8786 11.7628 16.5861 11.47L12.5911 7.47Z" fill="currentColor" /></svg></svg>
            {t('View')}
          </Link>
        </CardActions>
      )}
    </CardRootElement>
  );
};

CardDetails.propTypes = {
  displayName: PropTypes.string,
  logo: PropTypes.string,
  headline: PropTypes.string,
  eyebrow: PropTypes.string,
  handleViewMore: PropTypes.func,
  type: PropTypes.string,
  localImg: PropTypes.bool,
  view: PropTypes.bool,
  outsideClass: PropTypes.string,
  dataWatVal: PropTypes.string,
  dataWatLoc: PropTypes.string,
  cardDescClass: PropTypes.string,
  link: PropTypes.string,
  isTitleTranslate: PropTypes.bool,
};

CardDetails.defaultProps = {
  type: '',
  displayName: '',
  logo: '',
  headline: '',
  eyebrow: '',
  handleViewMore: () => {},
  localImg: false,
  view: false,
  outsideClass: '',
  dataWatLoc: '',
  dataWatVal: '',
  cardDescClass: '',
  link: '',
  isTitleTranslate: true,
};
export default CardDetails;
